import Icons from '../../../components/icons';
import routes from '../../../constants/routes';
import { NavItem } from '../types';
import { NativePage } from './nativePages';

const navigationConfig = [
  {
    title: 'Home',
    value: 'Dashboard',
    iconName: 'AdminHome'
  },
  {
    title: 'Admin',
    value: 'Admin',
    iconName: 'Admin',
    children: [
      {
        title: 'Staff Profiles',
        value: NativePage.SCHOOL_STAFF_SEARCH,
        mixpanelEvent: 'staff_profiles_clicked'
      },
      {
        title: 'Hashtags',
        value: NativePage.HASHTAGS_MANAGEMENT,
        mixpanelEvent: 'hashtags_clicked'
      },
      {
        title: 'Moderation Settings',
        value: NativePage.SCHOOL_CONFIGURATIONS,
        mixpanelEvent: 'moderation_settings_clicked'
      },
      {
        title: 'Declaration Setup',
        value: NativePage.DECLARATIONS,
        mixpanelEvent: 'declaration_setup_clicked'
      }
    ]
  },
  {
    title: 'Student',
    value: 'Student',
    iconName: 'Student',
    children: [
      {
        title: 'Student Profiles',
        value: NativePage.STUDENT_PROFILE,
        mixpanelEvent: 'student_profiles_clicked'
      },
      {
        title: 'Roll No. Update',
        value: NativePage.ROLL_NO_UPDATE,
        mixpanelEvent: 'roll_no_update_clicked'
      },
      {
        title: 'ID Cards',
        value: NativePage.PHOTO_ID_CARDS,
        mixpanelEvent: 'id_cards_clicked'
      },
      {
        title: 'Import Users',
        value: NativePage.IMPORT_USERS,
        mixpanelEvent: 'import_users_clicked',
        enabled: false
      }
    ]
  },
  {
    title: 'Fee Setup',
    value: 'Fee Setup',
    iconName: 'FeeSetup',
    children: [
      {
        title: 'Fee Structure',
        value: NativePage.FEE_STRUCTURE_PAGE,
        mixpanelEvent: 'fee_structure_clicked'
      },
      {
        title: 'Full Payment Concession',
        value: NativePage.FULL_PAYMENT_CONCESSION,
        mixpanelEvent: 'full_payment_concession_clicked'
      }
    ]
  },
  {
    title: 'Fee Collection',
    value: 'Fee Collection',
    iconName: 'FeeCollection',
    children: [
      {
        title: 'Student Fee Entry',
        value: NativePage.SEARCH_STUDENT_FEE_ENTRY,
        path: routes.SEARCH_STUDENT_FEE_ENTRY,
        mixpanelEvent: 'search_student_fee_entry_clicked'
      },
      {
        title: 'Cheque Status Update',
        value: NativePage.IMPORT_CHEQUE_STATUS_REPORT,
        mixpanelEvent: 'cheque_status_update_clicked'
      },
      {
        title: 'Transaction Status Update',
        value: NativePage.IMPORT_TRANSACTION_STATUS_REPORT,
        mixpanelEvent: 'transaction_status_update_clicked'
      }
    ]
  },
  {
    title: 'Fee Reports',
    value: 'Fee Reports',
    iconName: 'FeeReports',
    children: [
      {
        title: 'Pending Fee Report',
        value: NativePage.PENDING_FEE_REPORT,
        mixpanelEvent: 'pending_fee_report_clicked'
      },
      {
        title: 'Pending Fee Summary',
        value: NativePage.PENDING_FEE_SUMMARY_REPORT,
        mixpanelEvent: 'pending_fee_summary_clicked'
      },
      {
        title: 'Outstanding Fee Report',
        value: NativePage.OUTSTANDING_FEE_REPORT,
        mixpanelEvent: 'outstanding_fee_report_clicked'
      },
      {
        title: 'Daily Fee Book',
        value: NativePage.DAILY_FEE_BOOK_PAGE,
        mixpanelEvent: 'daily_fee_book_clicked'
      },
      {
        title: 'Cheque Detail Report',
        value: NativePage.CHEQUE_DETAIL_REPORT,
        mixpanelEvent: 'cheque_detail_report_clicked'
      },
      {
        title: 'Cash Flow Statement',
        value: NativePage.CASH_FLOW_STATEMENT,
        mixpanelEvent: 'cash_flow_statement_clicked'
      },
      {
        title: 'Cancelled Payments Log',
        value: NativePage.CANCELLED_PAYMENTS_LOG,
        mixpanelEvent: 'cancelled_payments_log_clicked'
      }
    ]
  },
  {
    title: 'Academics',
    value: 'Academics',
    iconName: 'Academics',
    children: [
      {
        title: 'Subjects & Grouping',
        value: NativePage.SUBJECTS_MANAGEMENT,
        mixpanelEvent: 'subjects_and_grouping_clicked'
      },
      {
        title: 'Academic Terms',
        value: NativePage.ACADEMIC_YEAR_WISE_TERMS,
        mixpanelEvent: 'academic_terms_clicked'
      },
      {
        title: 'Exam Setup',
        value: NativePage.EXAMS,
        mixpanelEvent: 'exam_setup_clicked'
      },
      {
        title: 'Scoring Types',
        value: NativePage.SCORING_TYPES,
        mixpanelEvent: 'scoring_types_clicked',
        enabled: false
      },
      {
        title: 'Electives Assignment',
        value: NativePage.STUDENT_ELECTIVE_SUBJECTS_MAPPING,
        mixpanelEvent: 'electives_assignment_clicked'
      },
      {
        title: 'Assessment Overview',
        value: NativePage.ASSESSMENTS_OVERVIEW,
        mixpanelEvent: 'assessment_overview_clicked'
      },
      {
        title: 'Provisional Promotion',
        value: NativePage.PROVISIONAL_PROMOTION,
        mixpanelEvent: 'provisional_promotion_clicked'
      },
      {
        title: 'Final Promotion',
        value: NativePage.FINAL_PROMOTION,
        mixpanelEvent: 'final_promotion_clicked'
      }
    ]
  },
  {
    title: 'Analytics & Reports',
    value: 'Analytics & Reports',
    iconName: 'Analytics',
    children: [
      {
        title: 'LC Report',
        value: NativePage.LC_REPORT,
        mixpanelEvent: 'lc_report_clicked'
      },
      {
        title: 'Attendance Report',
        value: NativePage.ATTENDANCE_TRACKING_REPORT,
        mixpanelEvent: 'attendance_report_clicked'
      },
      {
        title: 'Report Card Generation',
        value: NativePage.CONSOLIDATED_MARKS_REPORT,
        mixpanelEvent: 'report_card_generation_clicked'
      },
      {
        title: 'Marks Analytics',
        value: NativePage.MARKS_ANALYTICS,
        mixpanelEvent: 'marks_analytics_clicked'
      },
      {
        title: 'Promotion Overview',
        value: NativePage.ROLLOVER_DASHBOARD,
        mixpanelEvent: 'promotion_overview_clicked'
      },
      {
        title: 'Promotion Breakdown',
        value: NativePage.ROLLOVER_DASHBOARD_SCHOOL_AND_GRADEWISE,
        mixpanelEvent: 'promotion_breakdown_clicked'
      },
      {
        title: 'Promotion Status Report',
        value: NativePage.ROLLOVER_STATUS,
        mixpanelEvent: 'promotion_status_report_clicked'
      }
    ]
  },
  {
    title: 'Transport',
    value: 'Transport',
    iconName: 'Transport',
    children: [
      {
        title: 'Bus & Device Setup',
        value: NativePage.BUSES,
        mixpanelEvent: 'bus_and_device_setup_clicked'
      },
      {
        title: 'Routes & Stops Setup',
        value: NativePage.ROUTES_MANAGEMENT,
        mixpanelEvent: 'routes_and_stops_setup_clicked'
      },
      {
        title: 'Live Trips Dashboard',
        value: NativePage.LIVE_TRIPS,
        mixpanelEvent: 'live_trips_dashboard_clicked'
      },
      {
        title: 'Student Transport Report',
        value: NativePage.STUDENT_TRANSPORT_REPORT,
        mixpanelEvent: 'student_transport_report_clicked'
      }
    ]
  }
];

const isEnabled = (item: { enabled?: boolean }) => item.enabled !== false;

const buildIcon = (iconName?: string) =>
  iconName
    ? {
        filled: Icons[`${iconName}Filled`],
        unfilled: Icons[`${iconName}Outline`],
        white: Icons[`${iconName}White`]
      }
    : undefined;
const filterEnabledChildren = (child: NavItem): NavItem => {
  const children = child.children?.filter(isEnabled).map(filterEnabledChildren);
  return {
    ...child,
    children,
    icon: buildIcon(child.iconName) || child.icon
  } as NavItem;
};

const useNavigation = (): NavItem[] =>
  (navigationConfig as NavItem[]).filter(isEnabled).map(filterEnabledChildren);

const iconBgColorMap: Record<string, string> = {
  Admin: '#FA757A',
  Academics: '#9886FE',
  'Fee Setup': '#16B364',
  'Fee Collection': '#FCAB28',
  'Fee Reports': '#FCAB28',
  'Analytics & Reports': '#FA757A',
  Transport: '#9886FE',
  Student: '#16B364'
};

const customOrder = [
  'Admin',
  'Fee Reports',
  'Academics',
  'Student',
  'Fee Setup',
  'Analytics & Reports',
  'Fee Collection',
  'Transport'
];

export { useNavigation, iconBgColorMap, customOrder };
